import { JsonViewer } from '@textea/json-viewer';
import { useContext, useState } from 'react';
import { useAsyncEffect } from '../../../../hooks/UseAsyncEffect';
import { toFormattedDate } from '../../../../utilities/FormatHelpers';
import { AccountContext } from "../../AccountContext";

export function OpenJobs(props: {onJobRun: any}) {
    const { accountId, regularPaymentService, setBillingDate } = useContext(AccountContext);
    const [loading, setLoading] = useState(false as boolean);
    const [openJobs, setOpenJobs] = useState([]);

    useAsyncEffect(async () => {
        try {
            setLoading(true);
            fetchData();
        } catch (error) {
        } finally {
            setLoading(false);
        }
    }, [accountId]);

    async function fetchData()
    {
        var response = await regularPaymentService.getOpenJobs(accountId);
        setOpenJobs(response);
    }

    function getNextJob()
    {
        if (openJobs && openJobs.length > 0)
        {
            var nextJob =  openJobs.reduce(function (accumulatedValue, currentValue) {
                if(new Date(accumulatedValue.startDate).getTime() > new Date(currentValue.startDate).getTime())
                {
                    return currentValue;
                };
                return accumulatedValue;
              });
            
            return nextJob;
        }
        return null;
    }

    async function handleRunNextJob() {
        setLoading(true);
        var nextJob = getNextJob();
        setBillingDate(new Date(nextJob.startDate));
        await regularPaymentService.runJobs(accountId, new Date(nextJob.startDate)); 
        setTimeout(async () => {
            await fetchData();
            props.onJobRun();
            setLoading(false);
        }, 500);
    }

    async function refresh()
    {
        setLoading(true);
        await fetchData();
        setLoading(false);
    }

    return (<>
        <h2>Open Jobs ({openJobs.length}) </h2>
        <div>
            <div className="ui">
                <button 
                    className={"ui button"} 
                    type="button" onClick={async () => await handleRunNextJob()}
                    disabled={!openJobs || openJobs.length <= 0}>
                        <i className="ui icon play"/>
                        Run for date {toFormattedDate(getNextJob()?.startDate)}
                </button>
                <button 
                    className={`ui secondary ${loading ? 'loading': ''} button `} 
                    type="button" onClick={async () => await refresh()}>
                        <i style={{margin: 0}} className="ui icon refresh"/>
                </button>
            </div>
        </div>
        {loading && <div className="ui active centered inline loader" />}
        {!loading && openJobs && openJobs.length > 0 ? <section>
            {openJobs.map(j => {
                return (
                    <div key={j.id} className="ui card">
                        <div className="custom-card-header">
                            <span>{j.jobType}</span>
                            <p style={{fontSize: "12px"}}>{toFormattedDate(j.startDate)}</p>
                        </div>
                        <div className="content">
                            <div className="field">
                                <JsonViewer 
                                    value={j.jobData} 
                                    rootName={"jobData"} 
                                    defaultInspectDepth={0}
                                    displayObjectSize={false}
                                    displayDataTypes={false} />
                            </div>
                        </div>
                    </div>
                );
            })}
        </section> : null }
    </>)
}
